export const ACTIVITY_LOGS = 'activity_logs'
